const filePathArr = location.pathname.split('/')
filePathArr.pop()
const baseFilePath = location.origin + filePathArr.join('/') // 获取app入口file协议的绝对路径
const isDev = process.env.NODE_ENV === 'development'
const isLocal = process.env.VUE_APP_ENV === 'localhost'

export default {
  ngApp: {
    name: 'ngApp', // 应用名称
    url: isLocal
      ? 'http://localhost:63344'
      : baseFilePath + '/angular_index.html', // 应用入口 实际开启子应用的端口号
    baseroute: '/angular', // 子应用的基础路由
    inline: isDev ? true : false, // 开启inline后，被提取的js会作为script标签插入应用中运行，在开发环境中更方便调试。
    'keep-alive': true, // 缓存应用
  },
  vueApp: {
    name: 'vueApp',
    url: isLocal ? 'http://localhost:63343' : baseFilePath + '/vue/index.html',
    baseroute: '/vue',
    inline: isDev ? true : false,
    'keep-alive': true,
  },
}
